import React from "react";

import { Text } from "/component/base";

import { Base, Link, LinkItem, TabButton } from "./TopTabBar.styles";
import { Props } from "./TopTabBar.types";
/**
 * TopTabBar renders a `<nav>` containing a list of links (<a>) that will navigate based on
 * the `to` value in the link.
 *
 * You can optionally provide a before/after element. The `after` element will commonly be used
 * to render a filter button to the right of the navigation.
 */
const TopTabBar = ({ className, after, before, links, onClick, asButton, disabled }: Props) => {
  return (
    <Base className={className}>
      {before}
      <nav>
        <ul>
          {links.map(({ to, label, isActive, replace }) => (
            <LinkItem key={label}>
              {asButton ? (
                <TabButton
                  disabled={disabled || isActive}
                  $isActive={isActive}
                  onClick={() => {
                    onClick && onClick(to.toString());
                  }}
                >
                  <Text color="inherit" variant={isActive ? "body1Bold" : "body1"}>
                    {label}
                  </Text>
                </TabButton>
              ) : (
                <Link exact to={to} $isActive={isActive} replace={replace}>
                  <Text color="inherit" variant={isActive ? "body1Bold" : "body1"}>
                    {label}
                  </Text>
                </Link>
              )}
            </LinkItem>
          ))}
        </ul>
      </nav>

      {after}
    </Base>
  );
};

export default TopTabBar;
